import { render } from "./InboxComponent.vue?vue&type=template&id=cb0b6a7e"
import script from "./InboxComponent.vue?vue&type=script&lang=js"
export * from "./InboxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__